.wrapper {
	min-width: max-content;
	grid-template-areas: "stack";
	justify-items: center;
	align-items: center;
}

.contents {
	display: flex;
	align-items: center;
	gap: var(--size-3);

	text-box: inherit;

	.wrapper:has(.loader) & {
		visibility: hidden;
	}
}

.layer {
	grid-area: stack;
}
